/**
 * The brand-typography catalogue is 36 self-hosted families (~2 MB). Loading it at boot
 * would make every user pay for a modal most of them never open, so the stylesheet is
 * injected the first time a screen actually previews a brand font.
 *
 * The browser still only downloads the woff2 files whose text is on screen: the picker
 * grid pulls the whole catalogue, a brand card pulls the two families it displays.
 *
 * Generated by scripts/fetch-fonts.mjs. Re-run it after editing the picker catalogue.
 */
const STYLESHEET_ID = 'brand-fonts';
const STYLESHEET_HREF = '/fonts/brand-fonts.css';

export const loadBrandFonts = (): void => {
  if (typeof document === 'undefined' || document.getElementById(STYLESHEET_ID)) {
    return;
  }

  const link = document.createElement('link');
  link.id = STYLESHEET_ID;
  link.rel = 'stylesheet';
  link.href = STYLESHEET_HREF;
  document.head.appendChild(link);
};
